import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 22px;

	& > ${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

export { StyledContainer };
